<template>
    <b-row class="vh-100 text-center" align-v="center" v-if="!app">
        <b-col>
            <b-spinner variant="light" />
        </b-col>
    </b-row>
    <div v-else>
        <PowerApp :dist="app.dist" :app="app"/>
    </div>
</template>

<style scoped lang="scss">
.settings {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: auto;
    background-color: var(--bg-card);
    border-radius: 10px 0px 0px 10px;
    right: -45px;
    opacity: 0.5;
    z-index: 9999;

    &.active {
        right: 0;
        opacity: 1;
    }

    .btn {
        display: block;
        margin: 10px;
    }

    .caret {
        position: absolute;
        color: var(--text-primary);
        padding: 10px;
        top: 50%;
        transform: translateY(-50%);
        background-color: inherit;
        padding: 20px 5px;
        left: -15px;
        border-radius: 10px;
        cursor: pointer;
    }
}

</style>

<style>
.tawk-min-container {
    display: none;
}
</style>

<script>
import PowerApp from './PowerApp'

export default {
    name: 'App',
    components: {
        PowerApp,
    },
    data: function() {
        return {
            app: null
        }
    },

    methods: {
        goToEditor(app) {
            console.log(app)
        }
    },

    async mounted() {
        try {
            let { data: app } = await this.$http.get(`/v3/system/gateway/app-service/app/${this.$route.params.id}/dist`)
            this.app = app
       }  catch(err) {
            this.$debugLog(err)
           this.$mainDialog.msgBoxOk("Failed to fetch app.")
        }

        this.$store.commit("SET_CURRENT_CONTEXT", "platform-app")
    }
}
</script>